import React from 'react';

// TODO DEPRECATED

const renderField = ({ placeholder, hidden, input, label, wrapperClass, type, isNew, meta: { dirty, touched, error } }) => {
  const getLabel = ()=> (label && <label htmlFor={input.id || input.name}>{label}</label>)
  const isDirty = ()=> dirty && !isNew

  return(
    <div className={`${type} ${wrapperClass} input form-group form-group-default`}>
      {type!=='checkbox' && getLabel()}
      <input className={`form-control no-box-shadow ${isDirty() ? 'dirty-input' : ''}`} id={input.name} {...input} type={type} placeholder={placeholder} />
      {type==='checkbox' && getLabel()}
      {touched && error && <span className='error'>{error}</span>}
    </div>
  )
}

export default renderField;
